// API utilities for user data

/**
 * Fetches all users from the server
 * @returns {Promise<Array>} Array of user objects
 */
export const fetchUsers = async () => {
  try {
    const response = await fetch("http://localhost:5001/api/users");

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const users = await response.json();
    return users;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

/**
 * Fetches a specific user by ID
 * @param {string} userId - The ID of the user to fetch
 * @returns {Promise<Object>} User object
 */
export const fetchUserById = async (userId) => {
  try {
    const response = await fetch(`http://localhost:5001/api/users/${userId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const user = await response.json();
    return user;
  } catch (error) {
    console.error(`Error fetching user with ID ${userId}:`, error);
    throw error;
  }
};
